import { useBreakpoint } from "@simplybusiness/mobius";
import { customBreakpoints } from "../../../../constants/breakpoints";
import type { CardModalProps } from "./CardModal";
import { CardModal } from "./CardModal";
import { CardPopover } from "./CardPopover";

export const InfoModal = ({ title, ...props }: CardModalProps) => {
  const { up } = useBreakpoint(customBreakpoints);

  if (up("md")) {
    return <CardPopover {...props} />;
  }

  return <CardModal title={title} {...props} />;
};
